let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("hV6C1")]).then(() => parcelRequire('10sHA'));